import { render, staticRenderFns } from "./flexTop.vue?vue&type=template&id=c5bb0284&scoped=true"
import script from "./flexTop.vue?vue&type=script&lang=js"
export * from "./flexTop.vue?vue&type=script&lang=js"
import style0 from "./flexTop.vue?vue&type=style&index=0&id=c5bb0284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bb0284",
  null
  
)

export default component.exports